import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, UserRound } from "lucide-react";
import { Button } from "./ui/button";
import { useAuth } from "../contexts/AuthContext";
import { toTitleCase } from "../lib/utils";

export function ImpersonationBanner() {
  const { user, isImpersonating, stopImpersonation } = useAuth();
  const navigate = useNavigate();
  const [exiting, setExiting] = useState(false);

  if (!isImpersonating || user?.type !== "staff") {
    return null;
  }

  async function handleExit() {
    setExiting(true);
    try {
      await stopImpersonation();
      navigate("/pilot/dashboard", { replace: true });
    } catch {
      window.alert("Could not return to your admin session. Please sign in again.");
      navigate("/pilot/login", { replace: true });
    } finally {
      setExiting(false);
    }
  }

  const displayName = toTitleCase(user?.full_name || "") || user?.full_name || "staff";

  return (
    <div className="border-b border-[#1E74FD]/20 bg-gradient-to-r from-[#1E74FD] to-blue-700 px-4 py-3 text-white shadow-md shadow-[#1E74FD]/20">
      <div className="mx-auto flex max-w-[95%] flex-col gap-3 xl:max-w-[98%] sm:flex-row sm:items-center sm:justify-between">
        <div className="flex min-w-0 items-start gap-3">
          <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white/20 ring-1 ring-white/30">
            <UserRound className="h-4 w-4 text-white" />
          </div>
          <div className="min-w-0">
            <p className="text-base font-semibold leading-snug text-white">
              Viewing as {displayName}
            </p>
            <p className="mt-0.5 text-sm leading-snug text-white/90">
              You are logged in as this staff account
              {user?.portal_id ? ` (${user.portal_id})` : ""}. Exit to return to your admin
              dashboard.
            </p>
          </div>
        </div>
        <Button
          type="button"
          size="sm"
          className="shrink-0 border border-white/40 bg-white text-[#1E74FD] hover:bg-white/90 hover:text-[#1558d6]"
          disabled={exiting}
          onClick={() => void handleExit()}
        >
          <LogOut className="mr-2 h-4 w-4" />
          {exiting ? "Exiting…" : "Exit staff view"}
        </Button>
      </div>
    </div>
  );
}
